module.exports = __webpack_public_path__ + "static/media/auth_logo_new_white.e0ba1e8b.png";